import React, { useState } from "react";
import strains from "../../local_data/strains";
import brands from "../../local_data/brands";
import dispensaries from "../../local_data/dispensaries";
import manufacturers from "../../local_data/manufacturers";
import terpenes from "../../local_data/terpene_types";
import fragrance from "../../local_data/fragrance_types";

import {
  Form,
  Input,
  Modal,
  Button,
  Select,
  Steps,
  Typography,
  Rate,
  message,
  DatePicker,
  Divider,
  AutoComplete,
} from "antd";
import { FrownOutlined, MehOutlined, SmileOutlined, PlusOutlined, SettingOutlined } from "@ant-design/icons";
import product_types from "../../local_data/product_types";
import BarCodeScanner from 'barcode-react-scanner';
 
interface RatingsProps {
  index: number;
}

const customIcons = [
  <FrownOutlined />,
  <FrownOutlined />,
  <MehOutlined />,
  <SmileOutlined />,
  <SmileOutlined />,
];

const initialValues = {
  batch_id: "",
  metric_id: "",
  thc: "",
  thca: "",
  thcv: "",
  delta8_thc: "",
  cbd: "",
  cbda: "",
  cbg: "",
  cbc: "",
  comments_enabled: false,
  product_type_id: "",
  fragrance_id: "",
  dispensary_id: ""!,
  strain_id: "",
  variety_name: "",
  origin_state: "",
  user_description: "",
  harvest_date: "",   
  user_id: "",   
};

interface Values {
  batch_id: string,
  metric_id: string,
  thc: string,
  thca: string,
  thcv: string,
  delta8_thc: string,
  cbd: string,
  cbda: string,
  cbg: string,
  cbc: string,
  comments_enabled: boolean,
  product_type_id: string,
  fragrance_id: string,
  dispensary_id: string,
  strain_id: string,
  variety_name: string,
  origin_state: string,
  user_description: string,
  harvest_date: string,   
  user_id: string,   
}

interface ProductSubmissionFormProps {
  id: string;
  visible: boolean;
  onCreate: (values: Values) => void;
  onCancel: () => void;
}

export const ProductSubmissionModal: React.FC<ProductSubmissionFormProps> = ({
  id,
  visible,
  onCreate,
  onCancel,
}) => {
  initialValues.user_id = id;
  const [form] = Form.useForm();
  const [current, setCurrent] = useState(0);
  const next = () => {
    setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const { Step } = Steps;
  const { Option } = Select;

  const steps = [
    {
      title: "Variety",
    },
    {
      title: "Terpenes",
    },
    {
      title: "Cannabinoids",
    }
  ];

  const [varietyOptions, setVarietyOptions] = useState(strains);
  const [brandOptions, setBrandOptions] = useState(brands);
  const [dispensaryOptions, setDispensaryOptions] = useState(dispensaries);
  const [manufacturOptions, setManufacturOptions] = useState(manufacturers);

  const onVarietySearch = (searchText: any) => {    
    const newOptions = varietyOptions.filter(option => option?.value?.toLowerCase().indexOf(searchText.toLowerCase()) >= 0)
    setVarietyOptions(newOptions);
  };
  const onBrandSearch = (searchText: any) => {    
    const newOptions = brandOptions.filter(option => option?.value?.toLowerCase().indexOf(searchText.toLowerCase()) >= 0)
    setBrandOptions(newOptions);
  };
  const onDispensarySearch = (searchText: any) => {    
    const newOptions = dispensaryOptions.filter(option => option?.value?.toLowerCase().indexOf(searchText.toLowerCase()) >= 0)
    setDispensaryOptions(newOptions);
  };
  const onManufacturerSearch = (searchText: any) => {    
    const newOptions = manufacturOptions.filter(option => option?.value?.toLowerCase().indexOf(searchText.toLowerCase()) >= 0)
    setManufacturOptions(newOptions);
  };

  const selectAfter = (id: string) => (
    <Select defaultValue="%" className="select-after">
      <Option value="%">%</Option>
      <Option value="mg">mg</Option>
    </Select>
  );

    
  return (
    <Modal
      visible={visible}
      title="Add Cannabis Product"
      onCancel={onCancel}
      footer={null}
    >
        <Steps size="small"  direction="vertical" current={current}>
          {steps.map((item) => (
            <Step key={item.title} title={item.title} />
          ))}
        </Steps>
      <Form
        form={form}
        layout="vertical"
        name="form_in_modal"
        initialValues={initialValues}
      >
        {" "}
        <div style={{ display: current === 0 ? "block" : "none" }}>
          <br /> 
          <Form.Item
            name="variety_name"
            label="Variety Name (Strain Name)"
            rules={[
              { required: true, message: "Please put in the variety name" },
            ]}
          >
            <AutoComplete
              options={varietyOptions}
              onSearch={onVarietySearch}
              placeholder="Search to Select"
            />
          </Form.Item>
          <Form.Item
            name="product_type_id"
            label="Product Type"
            rules={[
              { required: true, message: "Please put in the product type" },
            ]}
          >
            <Select
              showSearch
              placeholder="Search to Select"
              optionFilterProp="children"
              filterOption={(input, option) => {
                return (
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                );
              }}
              filterSort={(optionA, optionB) => {
                return optionA?.children
                  ?.toString()
                  .toLowerCase()
                  .localeCompare(optionB?.children?.toLowerCase());
              }}
            >
              {product_types?.map((data) => {
                return (
                  <Select.Option
                    key={data.product_type_name_en}
                    value={data.product_type_id}
                  >
                    {data.product_type_name_en}
                  </Select.Option>
                );
              })}
              ;
            </Select>
          </Form.Item>
          <Form.Item
            rules={[
              { required: true, message: "Please put in the Track and Trace ID" },
            ]}
            name="track_trace_id" 
            label="Track and Trace ID ( Metrc / Biotrack )"
            >
            <Input type="text" />
          </Form.Item>
          <Form.Item
            name="batch_id" 
            label="Batch Id"
            >
            <Input type="text" />
          </Form.Item>

          <Form.Item name="harvest_date" label="Harvest Date">
            <DatePicker />
          </Form.Item>
          <Form.Item name="brand_id" label="Farmer / Brand">
            <AutoComplete
                options={brandOptions}
                onSearch={onBrandSearch}
                placeholder="Search to Select"
              />
          </Form.Item>
          <Form.Item name="dispensary_id" label="Dispensary">
            <AutoComplete
                options={dispensaryOptions}
                onSearch={onDispensarySearch}
                placeholder="Search to Select"
              />
          </Form.Item>{" "}
        </div>
        <div style={{ display: current === 1 ? "block" : "none" }}>
          <br />
          <Typography.Paragraph>The more accurate and filled out this section is, the better your recommendations will be</Typography.Paragraph>
       
          <Form.Item
            name="fragrance_type_id"
            label="Fragrance"
          >
            <Select
              showSearch
              style={{ width: 200 }}
              placeholder="Search to Select"
              optionFilterProp="children"
              mode="multiple"
              filterOption={(input, option) => {
                return (
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                );
              }}
              filterSort={(optionA, optionB) => {
                return optionA?.children
                  ?.toString()
                  .toLowerCase()
                  .localeCompare(optionB?.children?.toLowerCase());
              }}
            >
              {fragrance?.map((data) => {
                return (
                  <Select.Option
                    key={data.fragrance_name_en}
                    value={data.fragrance_type_id}
                  >
                    {data.fragrance_name_en}
                  </Select.Option>
                );
              })}
              ;
            </Select>
          </Form.Item>
          <Form.Item
            name="terpene_type_id"
            label="Terpene Types"
          >
            <Select
              showSearch
              style={{ width: 200 }}
              placeholder="Search to Select"
              optionFilterProp="children"
              mode="multiple"
              filterOption={(input, option) => {
                return (
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                );
              }}
              filterSort={(optionA, optionB) => {
                return optionA?.children
                  ?.toString()
                  .toLowerCase()
                  .localeCompare(optionB?.children?.toLowerCase());
              }}
            >
              {terpenes?.map((data) => {
                return (
                  <Select.Option
                    key={data.terpene_name_en}
                    value={data.terpene_type_id}
                  >
                    {data.terpene_name_en}
                  </Select.Option>
                );
              })}
              ;
            </Select>
          </Form.Item>
        </div>
        <div style={{ display: current === 2 ? "block" : "none" }}>
          <br />
          <Typography.Paragraph>The more accurate and filled out this section is, the better your recommendations will be</Typography.Paragraph>
       
          <Form.Item name="thc" label="THC">
            <Input type="text" addonAfter={selectAfter('thc')} />
          </Form.Item>
          <Form.Item name="thca" label="THCA" >
            <Input type="text" addonAfter={selectAfter('thca')} />
          </Form.Item>
          <Form.Item name="thcv" label="THCV">
            <Input type="text" addonAfter={selectAfter('thcv')} />
          </Form.Item>
          <Form.Item name="cbd" label="CBD">
            <Input type="text" addonAfter={selectAfter('cbd')} />
          </Form.Item>
          <Form.Item name="cbda" label="CBDA">
            <Input type="text" addonAfter={selectAfter('cbda')} />
          </Form.Item>
          <Form.Item name="cbg" label="CBG">
            <Input type="text" addonAfter={selectAfter('cbg')} />
          </Form.Item>
          <Form.Item name="cbc" label="CBC">
            <Input type="text" addonAfter={selectAfter('cbc')} />
          </Form.Item>
          {/* <Form.Item name="cbn" label="CBN">
            <Input type="text" addonAfter={selectAfter('cbn')} />
          </Form.Item> */}
          <Form.Item name="delta8_thc" label="Delt8THC(%)">
            <Input type="text" addonAfter={selectAfter('delta8_thc')} />
          </Form.Item>
        </div>
        
        <div className="steps-action">
          {current < steps.length - 1 && (
            <Button type="primary" onClick={() => {
              return form
              .validateFields()
              .then(() => next())
              .catch((e) => {console.log(e)}
              )}}>
              Next
            </Button>
          )}
          {/* 
            TODO: Revisist and change for each value to be unique in DB
          */} 
          {current === steps.length - 1 && (
            <Button
              type="primary"
              onClick={() => {
                form
                  .validateFields()
                  .then((values) => {
                    const newValues = values;
                    newValues.terpene_type_id = newValues?.terpene_type_id?.toString();
                    newValues.fragrance_type_id = newValues?.fragrance_type_id?.toString();
                    newValues.comments_enabled = false;
                    // TODO: remove comment
                    //form.resetFields();
                    onCreate(newValues);
                    message.success("Product Added!");
                  })
                  .catch((info) => {
                    console.log("Validate Failed:", info);
                  });
              }}
            >
              Done
            </Button>
          )}
          {current > 0 && (
            <Button style={{ margin: "0 8px" }} onClick={() => prev()}>
              Previous
            </Button>
          )}
        </div>
      </Form>
    </Modal>
  );
};
